import { Provider }             from 'react-redux'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment }        from '@mui/x-date-pickers/AdapterMoment'
import { store } from './store/Beacon4BlendedStore';
import App          from './App'

export default function Beacon4Synthesis() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Provider store={store}>
        <App />
      </Provider>
    </LocalizationProvider>
  )
}
